import Vue from 'vue';

const state = {
    items: [],
};

const mutations = {
    changeSliderParams(state, items) {
        state = Object.assign(state, items)
    }
};

const getters = {
    getItemsLength: state => state.items.length,
    getSliderItems: (state, getters) => (mq) => {
        let items = [];
        if (state.items.length === 0) {
            items = [
                {id: 1, image: ''},
                {id: 2, image: ''},
                {id: 3, image: ''},
                {id: 4, image: ''},
            ];
            return items;
        }
        if (mq.xs) {
            state.items.forEach(item => {
                let slide = Object.assign({}, item);
                if (slide.image_xs !== '')
                    slide.image = getters.getFilePath + slide.image_xs;
                if (slide.city === getters.getUserCity.value || slide.city === 0)
                    items.push(slide);
            });
        } else if (mq.sm || mq.md) {
            state.items.forEach(item => {
                let slide = Object.assign({}, item);
                if (slide.image_md !== '')
                    slide.image = getters.getFilePath + slide.image_md;
                if (slide.city === getters.getUserCity.value || slide.city === 0)
                    items.push(slide);
            });
        } else {
            state.items.forEach(item => {
                let slide = Object.assign({}, item);
                if (slide.image_lg !== '')
                    slide.image = getters.getFilePath + slide.image_lg;
                if (slide.city === getters.getUserCity.value || slide.city === 0)
                    items.push(slide);
            });
        }
        return items;
    }
};

const actions = {
    setSliderItems({commit}) {
        commit('createProcess', 'slider');
        Vue.http.get(this.getters.getApiUrl + 'v1/sliders?filter[active]=1&sort=sort').then(response => {
            commit('changeSliderParams', {items: response.data});
            commit('setProcessSuccess', 'slider');
        }, response => {
            commit('changeSliderParams', {items: []});
            commit('setProcessFailed', {id: 'slider', message: response.body.message});
        });
    },
};

export default {
    state,
    mutations,
    getters,
    actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/slider.js